import * as React from 'react';
// @ts-expect-error
import {components} from 'react-select';

import {IconAndLabel} from 'shells/select-two-line-icon/icon-and-label';
import {SelectTwoLineIcon} from 'shells/select-two-line-icon/select-two-line-icon';
import type {TwoLineOptionWithIcon} from 'shells/select-two-line-icon/select-two-line-icon';

import type {MeetingLocationType} from 'nutshell-graphql-types';
import type {MeetingFragment as Meeting, MeetingUpdateInput} from 'nutshell-graphql-types';

import {LOCATION_OPTIONS, MODAL_MAP} from './consts';

import styles from './location-select.module.css';

type Props = {
    locationType: MeetingLocationType;
    onSave: (arg1: MeetingUpdateInput) => void;
    meeting: Meeting;
};

export function LocationSelect(props: Props) {
    const availableOptions = React.useMemo(() => {
        if (props.meeting.isManagedTemplate) {
            return LOCATION_OPTIONS.filter((option) => option.value !== 'INBOUND_CALL');
        }

        return LOCATION_OPTIONS;
    }, [props.meeting.isManagedTemplate]);

    const selectedOptionValue = availableOptions.find((option) => {
        return option.value === props.locationType;
    });

    const [selectedValue, setSelectedValue] = React.useState<
        TwoLineOptionWithIcon | null | undefined
    >(selectedOptionValue);
    const [isViewingModal, setIsViewingModal] = React.useState<boolean>(false);

    const resetValue = () => setSelectedValue(selectedOptionValue);

    const onFailToConnect = () => {
        // if the modal is closed without a successful connection, reset select to props.locationType
        resetValue();
        // close modal
        setIsViewingModal(false);
    };

    const ModalComponent =
        // @ts-expect-error
        isViewingModal && selectedValue ? MODAL_MAP[selectedValue.value] : undefined;

    return (
        <>
            <SelectTwoLineIcon
                customSecondLine={getLocationSublabelForMeeting(selectedValue, props.meeting)}
                options={availableOptions}
                value={selectedValue || null}
                placeholder='Select a location'
                onChange={(value: TwoLineOptionWithIcon) => {
                    setSelectedValue(value);
                    setIsViewingModal(true);
                }}
                hasGenericStyles={true}
                height={selectedValue ? 48 : 31}
                components={{
                    SingleValue,
                }}
                onClear={() => {
                    setSelectedValue(null);
                    props.onSave({id: props.meeting.id, locationType: 'NONE', location: null});
                }}
            />
            {ModalComponent && selectedValue ? (
                <ModalComponent
                    modalType={selectedValue.value}
                    meeting={props.meeting}
                    onSave={props.onSave}
                    onFailToConnect={onFailToConnect}
                    closeModal={() => setIsViewingModal(false)}
                />
            ) : undefined}
        </>
    );
}

function getLocationSublabelForMeeting(
    selectedValue: TwoLineOptionWithIcon | null | undefined,
    meeting: Meeting
): string | null | undefined {
    if (!selectedValue) {
        return null;
    } else if (
        selectedValue.value === 'ADDRESS' &&
        meeting.locationType === 'ADDRESS' &&
        meeting.location
    ) {
        return meeting.location;
    } else {
        return null;
    }
}

// @ts-expect-error
const SingleValue = (singleValueProps) => {
    return (
        <div className={styles['single-value']}>
            <components.SingleValue {...singleValueProps}>
                <IconAndLabel
                    icon={singleValueProps.data.icon}
                    label={singleValueProps.data.label}
                    sublabel={
                        singleValueProps.selectProps.customSecondLine ||
                        singleValueProps.data.sublabel
                    }
                />
            </components.SingleValue>
        </div>
    );
};
